import {jsonMember, jsonObject} from "typedjson";
import {PitRequestCriteria} from "./pit-request-criteria";

/** Структура типового запроса данных с бэка */

@jsonObject
export class PitRequestBody {

  /** Идентификатор узла-представления */
  @jsonMember({name: "presetViewItemId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _presetViewItemId: number;

  /** бюджетный период */
  @jsonMember({name: "budgetPeriod", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _budgetPeriod: number;

  /** Набор критериев для выборки */
  @jsonMember({name: "criteria", constructor: PitRequestCriteria, emitDefaultValue: false, isRequired: false })
  private _criteria: PitRequestCriteria = new PitRequestCriteria();

  get presetViewItemId(): number {
    return this._presetViewItemId;
  }

  set presetViewItemId(value: number) {
    this._presetViewItemId = value;
  }

  get criteria(): PitRequestCriteria {
    return this._criteria;
  }

  set criteria(value: PitRequestCriteria) {
    this._criteria = value;
  }

  get budgetPeriod(): number {
    return this._budgetPeriod;
  }

  set budgetPeriod(value: number) {
    this._budgetPeriod = value;
  }

  
  constructor(fields?: Partial<PitRequestBody>) {
    if (fields)
      Object.assign(this, fields);
  }
}
